import UserPreferencesConstants from 'sharedreact/constants/UserPreferencesConstants';
import type ErrorData from 'sharedreact/data/ErrorData';
import AppDispatcher from 'sharedreact/dispatcher/AppDispatcher';
import UserPreferencesStore from 'sharedreact/stores/UserPreferencesStore';
import ConnectionSupport from 'sharedreact/utils/ConnectionSupport';

// private functions
function fetchSuccess (values?: object): void {
  AppDispatcher.dispatch({
    actionType: UserPreferencesConstants.GET_SUCCESS,
    preferences: values,
    logLevel: 'debug'
  });
}

function clearSuccess (): void {
  AppDispatcher.dispatch({
    actionType: UserPreferencesConstants.CLEAR_SUCCESS,
    logLevel: 'debug'
  });
}

function clearFailed (error: ErrorData): void {
  AppDispatcher.dispatch({
    actionType: UserPreferencesConstants.CLEAR_FAILED,
    error: error,
    logLevel: 'debug'
  });
}

// exported functions
function setPreference (name: string, value: any): void {
  AppDispatcher.dispatch({
    actionType: UserPreferencesConstants.SET_PREFERENCE,
    name: name,
    value: value,
    logLevel: 'trace'
  });
}

function save (onSuccess?: () => void, onFailure?: (error: ErrorData) => void): void {
  const userPreferences = UserPreferencesStore.getState().toJS();
  ConnectionSupport.post(
    'services/saveUserPreferences',
    { key: 'UserPreferences', values: userPreferences },
    (data) => {
      if (onSuccess) {
        onSuccess();
      }
    },
    (error) => {
      console.log(error);
      if (onFailure) {
        onFailure(error);
      }
    },
    false
  );
}

function fetch (): void {
  ConnectionSupport.post(
    'services/getUserPreferences',
    { key: 'UserPreferences' },
    (data) => fetchSuccess(data.values),
    (error) => console.log(error),
    false
  );
}

function clear (): void {
  ConnectionSupport.post(
    'services/clearPreferences',
    {},
    clearSuccess,
    clearFailed,
    false
  );
}

export default {
  setPreference,
  save,
  fetch,
  clear
};
